// 🔑 THE FRAUD REVIEW QUEUE PAGE (Jesse, 2026-10-26): every open fraud flag across borrowers, with the Module's actions
// (components/admin/guidedReview/StaffQueues FraudReviewQueue). The Module's own steps keep their inline lists.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout';
import { FraudReviewQueue } from '../components/admin/guidedReview/StaffQueues';

export default function AdminFraudReview() {
  const navigate = useNavigate();
  return (
    <AdminLayout>
      <div style={{ padding: '32px', background: '#f7f7f7', minHeight: '100%' }}>
        <div style={{ maxWidth: 1180, margin: '0 auto', display: 'grid', gap: 16 }}>
          <button type="button" onClick={() => navigate('/admin/modules/underwriting')}
            style={{ justifySelf: 'start', minHeight: 44, padding: '0 16px', borderRadius: 10, border: '1px solid #000000', background: '#ffffff', color: '#000000', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>Back to Underwriting Modules</button>
          <FraudReviewQueue token={localStorage.getItem('doorly_admin_token')} navigate={navigate} />
        </div>
      </div>
    </AdminLayout>
  );
}
